/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Tab_AdvancedInputs */

const cs_builder_tab_advanced = /** @type {(inputs: Builder_Tab_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokročilé Typst`)
};

const en_builder_tab_advanced = /** @type {(inputs: Builder_Tab_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Typst`)
};

/**
* | output |
* | --- |
* | "Advanced Typst" |
*
* @param {Builder_Tab_AdvancedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_tab_advanced = /** @type {((inputs?: Builder_Tab_AdvancedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Tab_AdvancedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_tab_advanced(inputs)
	return cs_builder_tab_advanced(inputs)
});